@if (formGroup) {
  <form [formGroup]="formGroup" class="grid grid-cols-1 gap-3">
    <div class="flex gap-3 items-start">
      <mat-slide-toggle
        formControlName="shippingCostsExcluded"
        #toggler
        color="primary"
      >
        <span translate
          >CAMPAIGN_PERFORMANCE_FILTER_BEST_PRICE_EXCLUDE_SHIPPING</span
        >
      </mat-slide-toggle>

      <em-more-info
        class="ml-auto"
        [description]="'CAMPAIGN_PERFORMANCE_FILTER_OUTLIERS_DESCRIPTION'"
      ></em-more-info>
    </div>

    <mat-slide-toggle formControlName="excludeProducts" color="primary">
      <span>{{
        'CAMPAIGN_PERFORMANCE_FILTER_EXCLUDE_PRODUCTS_LABEL' | translate
      }}</span>
    </mat-slide-toggle>
  </form>
}
